<template>
  <div  class="tab_box">
     
     <ToolBar ref="actionbtn" @add="onAddBatchFeature" @del="onDelBatchFeature" isAdd isDel></ToolBar>
     <!-- :edit-render="{name: 'input', attrs: {type: 'text'}} -->
     <vxe-table
      border
      resizable
      ref="batchFeaturesTable"
      :data="batchFeaturesRowSet"
      :edit-config="{trigger: 'click', mode: 'cell'}"
      @cell-dblclick="onDbleTableCell">
      <vxe-table-column type="checkbox" width="40"></vxe-table-column>
      <!-- <vxe-table-column field="materialBatchFeaturesId" title="批次特性">
      </vxe-table-column> 
       <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
       <vxe-table-column field="specifications" title="规格（ML）">
      -->
      <vxe-table-column type="seq" field="specifications" title="规格（ML）">
      </vxe-table-column>
      <vxe-table-column field="groupBuyingIndicator" title="团购指示符">
        <template v-slot="{ row }">{{ formatIndicatorStatus(row.groupBuyingIndicator) }}</template>	
      </vxe-table-column>
      <vxe-table-column field="groupBuyingPrice" title="团购价">
      </vxe-table-column>
      <vxe-table-column field="wholesalesIndicator" title="批发指示符">
        <template v-slot="{ row }">{{ formatIndicatorStatus(row.wholesalesIndicator) }}</template>	
      </vxe-table-column>
      <vxe-table-column field="wholesalesPrice" title="批发价">
      </vxe-table-column>
      <vxe-table-column field="retailIndicator" title="零售指示符">
        <template v-slot="{ row }">{{ formatIndicatorStatus(row.retailIndicator) }}</template>	
      </vxe-table-column>
      <vxe-table-column field="retailPrice" title="零售价">
      </vxe-table-column>
      <vxe-table-column field="groupBuyingStandard" title="团购基准">
      </vxe-table-column>
      <vxe-table-column field="wholesalesStandard" title="批发基准">
      </vxe-table-column>
      <vxe-table-column field="retailStandard" title="零售基准">
      </vxe-table-column>
      <vxe-table-column field="validStartDate" title="有效期开始">
        <template v-slot="{ row }">{{ formatDate(row.validStartDate, 'yyyy/MM/dd') }}</template>	
      </vxe-table-column>
      <vxe-table-column field="validEndDate" title="有效期结束">
        <template v-slot="{ row }">{{ formatDate(row.validEndDate, 'yyyy/MM/dd') }}</template>	
      </vxe-table-column>
      <!-- <vxe-table-column field="deleteMark" title="删除标识">
      </vxe-table-column> -->
    </vxe-table>

    <el-dialog width="900px" customClass="dialog_detail_style" title="新增批次特性" :visible.sync="showBatchFeatureNeWin"
       @close="onCloseBatchFeatureNeWin" v-dialogDrag>
       <BatchFeatureNePanel class="contnet_box" ref="batchFeatureNePanel"
                    :batchFeature="batchFeatureRow"
                    :groupBuyingRecords="groupBuyingSpeciRecords"
                    :wholesalesRecords="wholesalesSpeciRecords"
                    :retailRecords="retailSpeciRecords"
                    :specificationRecords="specificationRecords"></BatchFeatureNePanel>
       <!-- 新增批次特性按钮 -->
       <div slot="footer" class="dialog-footer">
         <el-button @click="onCloseBatchFeatureNeWin">取 消</el-button>
         <el-button type="primary" @click="onSubmitBatchFeature">确 定</el-button>
       </div>
    </el-dialog>

      <!-- :batchFeatureList="batchFeatureList"
      :optionBatchFeatures="saleBatchFeatureArr" -->
  </div>
</template>

<script>
import ToolBar from 'components/btn/listBtn.vue';
import BatchFeatureNePanel from './BatchFeatureNePanel.vue'
import XEUtils from 'xe-utils'
  export default{
      components:{
         ToolBar,
         BatchFeatureNePanel
      },
      props:{
          batchFeatureFormData:Object,
          batchFeatureDataSet:{
              type:Array,
              default(){
                  return []
              }
          }
      },
      data(){
         return {
              batchFeaturesRowSet:this.batchFeatureDataSet,
              batchFeatureRow:{},
              showBatchFeatureNeWin:false,
              groupBuyingSpeciRecords:[],
              wholesalesSpeciRecords:[],
              retailSpeciRecords:[],
              specificationRecords:[]
         }
      },
      methods:{
          created(){
            Array.prototype.indexOf = function(val) {
              for (var i = 0; i < this.length; i++) {
              if (this[i] == val) return i;
              }
              return -1;
            };
            Array.prototype.remove = function(val) {
              var index = this.indexOf(val);
              if (index > -1) {
                 this.splice(index, 1);
              }
            };
            this.refSpecifications();
          },
          /**
           * 添加物料批次特性
           */
          onAddBatchFeature(){
            debugger;
            //参考规格
            if(!this.refSpecifications()){
              return;
            }

            //记录初始化
            this.batchFeatureRow={};
            this.batchFeatureRow.materialId=this.batchFeatureFormData.materialId;
            this.batchFeatureRow.materialCode=this.batchFeatureFormData.materialCode;
            this.batchFeatureRow.materialDesc=this.batchFeatureFormData.materialDesc;

            this.showBatchFeatureNeWin=true;
          },
          /**
           * 参考规格
           */
          refSpecifications(){
            if(!this.batchFeatureFormData){
               return false;
            }
            if(!this.batchFeatureFormData.groupBuyingStandard){
              this.$message.error('请在基准规格中，填入团购规格');
              return;
            }
            if(!this.batchFeatureFormData.wholesalesStandard){
              this.$message.error('请在基准规格中，填入批发规格');
              return false;
            }
            if(!this.batchFeatureFormData.retailStandard){
              this.$message.error('请在基准规格中，填入零售规格');
              return false;
            }

            if(!this.batchFeatureFormData.groupBuyingDouble){
              this.$message.error('请在加价倍数中，填入团购加倍');
              return false;
            }
            if(!this.batchFeatureFormData.wholesalesDouble){
              this.$message.error('请在加价倍数中，填入批发加倍');
              return false;
            }
            if(!this.batchFeatureFormData.retailDouble){
              this.$message.error('请在加价倍数中，填入零售加倍');
              return false;
            }
            if(!this.batchFeatureFormData.doublingCoefficient){
              this.$message.error('请在优惠折扣中，填入折扣率');
              return false;
            }
          
            //所有规格
            this.allSpeciRecords();
            //团购特性
            this.groupBuyingRecords();
            //批发特性
            this.wholesalesRecords();
            //零售
            this.retailRecords();

            return true;
          },
          /**
           * 所有批次特性规格
           */
          allSpeciRecords(){             
             this.specificationRecords=[];
             this.specificationRecords.push({
                    specifications:this.batchFeatureFormData.groupBuyingStandard
              });
             this.specificationRecords.push({
                  specifications:this.batchFeatureFormData.wholesalesStandard
              });
             this.specificationRecords.push({
                  specifications:this.batchFeatureFormData.retailStandard
             });
              //规格
             if(this.batchFeaturesRowSet){
                this.batchFeaturesRowSet.forEach(rowItem=>{                  
                  this.specificationRecords.push({
                     specifications:rowItem.specifications
                  });                  
                })
             }
          },          
          /**
           * 团购记录
           */
          groupBuyingRecords(){
            this.groupBuyingSpeciRecords=[];
            this.groupBuyingSpeciRecords.push({
                  specifications:this.batchFeatureFormData.groupBuyingStandard,
                  price:this.batchFeatureFormData.groupBuyingPrice,
                  discountRate:this.batchFeatureFormData.doublingCoefficient
            });
            //规格
            if(this.batchFeaturesRowSet){
              this.batchFeaturesRowSet.forEach(rowItem=>{
                  if(rowItem.groupBuyingIndicator!=1){
                    return;
                  }
                  this.groupBuyingSpeciRecords.push({
                     specifications:rowItem.specifications,
                     price:rowItem.groupBuyingPrice,
                     discountRate:this.batchFeatureFormData.doublingCoefficient
                  });                  
              })
            }
          },
          /**
           *批次特性规格 
           */
          batchFeatureSpecRecords(){
            this.wholesalesSpeciRecords=[];
            this.wholesalesSpeciRecords.push({
                  specifications:this.batchFeatureFormData.wholesalesStandard,
                  price:this.batchFeatureFormData.wholesalesPrice,
                  discountRate:this.batchFeatureFormData.doublingCoefficient
            });
            //规格
            if(this.batchFeaturesRowSet){
              this.batchFeaturesRowSet.forEach(rowItem=>{
                  if(rowItem.wholesalesIndicator!=1){
                    return;
                  }
                  this.wholesalesSpeciRecords.push({
                     specifications:rowItem.specifications,
                     price:rowItem.wholesalesPrice,
                     discountRate:this.batchFeatureFormData.doublingCoefficient
                  });                  
              })
            }
          },
          /**
           * 批发
           */
          wholesalesRecords(){
            this.wholesalesSpeciRecords=[];
            this.wholesalesSpeciRecords.push({
                  specifications:this.batchFeatureFormData.wholesalesStandard,
                  price:this.batchFeatureFormData.wholesalesPrice,
                  discountRate:this.batchFeatureFormData.doublingCoefficient
            });
            //规格
            if(this.batchFeaturesRowSet){
              this.batchFeaturesRowSet.forEach(rowItem=>{
                  if(rowItem.wholesalesIndicator!=1){
                    return;
                  }
                  this.wholesalesSpeciRecords.push({
                     specifications:rowItem.specifications,
                     price:rowItem.wholesalesPrice,
                     discountRate:this.batchFeatureFormData.doublingCoefficient
                  });                  
              })
            }
          },
          /**
           * 零售
           */
          retailRecords(){
            this.retailSpeciRecords=[];
            this.retailSpeciRecords.push({
                  specifications:this.batchFeatureFormData.retailStandard,
                  price:this.batchFeatureFormData.retailPrice,
                  discountRate:this.batchFeatureFormData.doublingCoefficient
            });
            //规格
            if(this.batchFeaturesRowSet){
              this.batchFeaturesRowSet.forEach(rowItem=>{
                  if(rowItem.retailIndicator!=1){
                    return;
                  }
                  this.retailSpeciRecords.push({
                     specifications:rowItem.specifications,
                     price:rowItem.retailPrice,
                     discountRate:this.batchFeatureFormData.doublingCoefficient
                  });                  
              })
            }
          },
          /**
           * 关闭批次窗口
           */
          onCloseBatchFeatureNeWin(){
            this.batchFeatureRow={};
            this.$refs.batchFeatureNePanel.clearCheckedIndicator();
            this.showBatchFeatureNeWin=false;
          },
          /**
           * 提交录入的批次特性
           */
          onSubmitBatchFeature(){  
            let arrIndex,record=this.batchFeaturesRowSet.find((item)=>item.specifications==this.batchFeatureRow.specifications);
            if(record){
               arrIndex=this.batchFeaturesRowSet.findIndex((item)=>item.specifications==this.batchFeatureRow.specifications);
               this.batchFeaturesRowSet.splice(arrIndex,1);
            }            
            
            debugger;
            //输出标识转换
            this.$refs.batchFeatureNePanel.outpuIndicatorCvt();
            this.$refs.batchFeatureNePanel.clearCheckedIndicator();

            this.batchFeaturesRowSet.push(this.batchFeatureRow);

            this.onCloseBatchFeatureNeWin();
          },
          /**
           * 删除物料批次特性
           */
          onDelBatchFeature(){            
             let dRecords = this.$refs.batchFeaturesTable.getCheckboxRecords();
             if(dRecords.length<=0){
                return;
             }
             this.$confirm('确认删除已选数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
             }).then(() => {
                 debugger;
                 this.$refs.batchFeaturesTable.removeSelecteds();                
                 let record,arrIndex;
                 for(let index in dRecords){
                     record=dRecords[index]; 
                     arrIndex=this.batchFeaturesRowSet.findIndex((item)=>item.specifications==record.specifications);
                     this.batchFeaturesRowSet.splice(arrIndex,1);
                 }
                 //findIndex((n) => n < 0)
                 //this.batchFeaturesRowSet.remove("50");
             });
             //console.log(this.batchFeaturesRowSet);
          },
          /**
           * 双击表格单元格
           */
          onDbleTableCell({row}){
            debugger;
            if(!row){
              return;
            }
             //参考规格
            if(!this.refSpecifications()){
              return;
            }  
            this.batchFeatureRow=row; 
            this.showBatchFeatureNeWin=true;
            //输入标识转换
            if(this.$refs.batchFeatureNePanel){
              this.$refs.batchFeatureNePanel.inputIndicatorCvt(row);  
            }                      
          },
          formatIndicatorStatus(statusValue){
            if(statusValue=="1"){
              return '开启'
            }else {
              //return '未开启'
              return '';
            }
          },
          formatDate (value, format) {
            if(!value){
                    return "";
            }
            return XEUtils.toDateString(value, format)
          },
          setBatchFeaturesRowSet(rowset){
            debugger;
             this.batchFeaturesRowSet=rowset;
          }
      }
  }
</script>

